module.exports = __webpack_public_path__ + "static/DarksideDetective1-cec2c6fda974a71666b15a937318e87d.png";